import { Transaction } from 'common/models/Transaction';

export function isSoftContinueEnabled(): boolean {
  return true;
}

export function isFinalValidationEnabled(): boolean {
  return true;
}

export function shouldExemptTransaction(_transaction: Transaction | null): boolean {
  return false;
}
